<template>
<md-card class="ql-cue" v-if="visible" v-bind:style="style()" :id="cue.id">
    <project-cues-cue-header 
        :expanded="expanded" 
        :cue="cue"
        :layer="layer"
        :layers="editableLayers" 
        :locked="locked"
        :editable="editable"
        :color="color"
        @toggle="toggle"
        @cueUpdated="updatedCue"/>
    <project-cues-cue-body v-show="expanded" 
        :cue="cue" 
        :locked="locked"
        :editable="editable"
        :color="color"
        @cueUpdated="updatedCue" 
        @destroy="destroy" />
</md-card>
</template>

<script>
import { mapGetters } from 'vuex';
/**
 * Component For...
 */
import ProjectCuesCueHeader from '@/components/project/cues/cue-header';
import ProjectCuesCueBody from '@/components/project/cues/cue-body';

const ProjectCuesCue = {
    name: 'projectCuesCue',
    props: ['cue', 'open', 'layers', 'locked'],
    data: function() {
        return {
            expanded: this.open
        };
    },
    computed: {
        ...mapGetters([
            'layerByCue',
            'editableLayers'
        ]),
        layer() {
            return this.layerByCue(this.cue);
        },
        visible() {
            let visible = true;
            
            if (this.layer) {
                if (this.layer.hidden === true) {
                    visible = false;
                }
            }
            return visible;
        },
        editable() {
            if (this.layer) {
                const filter = this.editableLayers.filter(l => l.id === this.layer.id);
                return filter.length > 0;
            }
            return false;
        },
        color() {
            let val = 'white';
            if (this.layer) {
                val = this.layer.color;
            }
            return val;
        }
    },
    methods: {
        toggle() {
            if (this.$props.cue) {
                if (this.expanded) {
                    this.contract();
                } else {
                    this.expand();
                }
            }
        },
        expand() {
            this.expanded = true;
            this.$emit('openCue', this.cue);
        },
        contract() {
            this.expanded = false;
            this.$emit('closeCue', this.cue);
        },
        destroy() {
            this.$emit('destroy', this.$props.cue);
        },
        style() {
            return {borderColor: this.color, top: `${this.cue.offsetY}px`, zIndex: this.expanded ? 12 : 11};
        },
        updatedCue(cue) {
            this.$emit('updatedCue', cue);
        }
    },
    components: {
        'project-cues-cue-body': ProjectCuesCueBody,
        'project-cues-cue-header': ProjectCuesCueHeader
    }
};

export default ProjectCuesCue;
</script>

<style lang="scss">
.ql-cue {
    position: absolute;
    width: 90%;
    height: auto;
    margin-bottom: 5px;
    top: 0;
    box-sizing: border-box;
    border: 1px solid #000;
    overflow: hidden;
    .md-card {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// cue.vue?36a84b5a